import {
  Box,
  Button,
  Grid,
  InputLabel,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import ConfirmModal from '../../../common/modals/ConfirmModal';
import BackButton from '../../../common/BackButton';
import useCarrierRequest from '../../../../requests/CarrierRequest';
import ProviderPicker from '../../../common/ProviderPicker';

const CarrierDeviceSingle = ({ carrierDevice, onBack, errorHandler }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [edits, setEdits] = useState({});

  const [showConfirmation, setShowConfirmation] = useState(false);

  const {
    createNewCarrierDevice,
    deleteCarrierDeviceById,
    updateCarrierDevice,
  } = useCarrierRequest();

  const performDelete = async () => {
    setIsDeleting(true);
    const result = await deleteCarrierDeviceById(
      carrierDevice.country_code_id,
      carrierDevice.carrier_id,
      carrierDevice.carrier_device_id,
      errorHandler
    );
    if (result.success) {
      onBack();
    }
    setIsDeleting(false);
  };

  const toggleEdit = () => {
    setIsEditing(!isEditing);
  };

  const handleFormChange = (name, newValue) => {
    setEdits((prev) => ({ ...prev, [name]: newValue }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const applyProvider =
      typeof edits.provider_id === 'undefined' || edits.provider_id
        ? 'this'
        : 'all';

    if (carrierDevice.carrier_device_id) {
      const result = await updateCarrierDevice(
        carrierDevice.country_code_id,
        carrierDevice.carrier_id,
        carrierDevice.carrier_device_id,
        edits,
        applyProvider,
        errorHandler
      );
      if (result.success) {
        toggleEdit();
      }
    }

    const result = await createNewCarrierDevice(
      carrierDevice.country_code_id,
      carrierDevice.carrier_id,
      edits,
      applyProvider,
      errorHandler
    );
    if (result.success) {
      toggleEdit();
    }
  };

  if (isEditing) {
    return (
      <Box component="form" onSubmit={handleSubmit}>
        <Grid container spacing={1} maxWidth={800}>
          <Grid size={12}>
            <Typography>
              <strong>Carrier:</strong> {carrierDevice.carrier_name}
            </Typography>
          </Grid>
          <Grid size={12}>
            <Typography>
              <strong>Device:</strong> {carrierDevice.device_name}
            </Typography>
          </Grid>
          <Grid size={12}>
            <Stack
              sx={{
                flexDirection: { md: 'row' },
                alignItems: { md: 'center' },
                gap: { md: 2 },
              }}
            >
              <InputLabel sx={{ minWidth: 100 }}>Apply To:</InputLabel>
              <ProviderPicker
                placeholder="All Providers"
                providerId={
                  edits.provider_id || carrierDevice?.provider_id || ''
                }
                optionName="provider_id"
                onChange={(_, newValue) => {
                  handleFormChange('provider_id', newValue);
                }}
                errorHandler={errorHandler}
                fullWidth
              />
            </Stack>
          </Grid>
          <Grid size={12}>
            <Stack
              sx={{
                flexDirection: { md: 'row' },
                alignItems: { md: 'center' },
                gap: { md: 2 },
              }}
            >
              <InputLabel sx={{ minWidth: 100 }} required>
                Priority:
              </InputLabel>
              <TextField
                name="priority"
                type="number"
                value={edits.priority || carrierDevice.priority || 35}
                fullWidth
                size="small"
                required
                onChange={(e) =>
                  handleFormChange('priority', parseInt(e.target.value))
                }
              />
            </Stack>
          </Grid>
          <Grid size={12}>
            <Box display="flex" gap={2}>
              <Button variant="text" color="secondary" onClick={toggleEdit}>
                Cancel
              </Button>
              <Button variant="contained" color="secondary" type="submit">
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  }

  return (
    <Stack>
      <Box>
        <BackButton onClick={() => onBack()} />
      </Box>

      <Grid container spacing={2}>
        <Grid size={12}>
          <Typography>
            <strong>Carrier:</strong> {carrierDevice.carrier_name}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography>
            <strong>Device:</strong> {carrierDevice.device_name}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography>
            <strong>Provider:</strong> {carrierDevice.provider_name}
          </Typography>
        </Grid>
        <Grid size={12}>
          <Typography>
            <strong>Priority:</strong> {carrierDevice.priority}
          </Typography>
        </Grid>

        <Grid size={12}>
          <Button variant="contained" color="secondary" onClick={toggleEdit}>
            Edit
          </Button>
          <Box sx={{ display: 'flex', justifyContent: 'end' }}>
            {!isDeleting && (
              <Button
                color="error"
                variant="contained"
                onClick={() => setShowConfirmation(true)}
              >
                Delete
              </Button>
            )}
            {isDeleting && 'Deleting...'}
          </Box>
        </Grid>
      </Grid>
      <ConfirmModal
        show={showConfirmation}
        onClose={() => setShowConfirmation(false)}
        onConfirm={performDelete}
        message="Are you sure you want to delete this carrier device?"
      />
    </Stack>
  );
};

export default CarrierDeviceSingle;
